import {onChildEvent} from "../services/dom";
import {Component} from "./component";

/**
 * AddRemoveFormRows
 */
export class AddRemoveFormRows extends Component {
    setup() {
        this.modelRow = this.$refs.model;
        this.addButton = this.$refs.add;
        this.removeSelector = this.$opts.removeSelector;
        this.rowSelector = this.$opts.rowSelector;
        this.initializeTinyMCE(this.modelRow);
        this.setupListeners();
    }

    setupListeners() {
        this.addButton.addEventListener('click', this.add.bind(this));

        onChildEvent(this.$el, this.removeSelector, 'click', (e) => {
            const row = e.target.closest(this.rowSelector);
            row.remove();
        });
    }

    setClonedInputNames(clone, index) {
        clone.dataset.index = index;
        // Update input names and IDs
        const inputElems = clone.querySelectorAll('input, textarea');
        for (const elem of inputElems) {
            const nameAttr = elem.getAttribute('name');
            if (nameAttr) {
                elem.name = nameAttr.replace(/\[\d+\]/, `[${index}]`);
                elem.id = nameAttr.replace(/\[\d+\]/, `_${index}_`);
            }
        }

        // Update image names and IDs (if applicable)
        const imageElems = clone.querySelectorAll('input[type="file"]');
        for (const imageElem of imageElems) {
            const nameAttr = imageElem.getAttribute('name');
            if (nameAttr) {
                imageElem.name = nameAttr.replace(/\[\d+\]/, `[${index}]`);
                imageElem.id = nameAttr.replace(/\[\d+\]/, `_${index}_`);
            }
        }

        const forElems = clone.querySelectorAll('label[class="button outline"]');
        for (const forElem of forElems) {
            const forAttr = forElem.getAttribute('for');
            if (forAttr) {
                forElem.setAttribute('for', forAttr.replace(/\[\d+\]/, `[${index}]`));
            }
        }

        // Update image names and IDs (if applicable)
        const selectElems = clone.querySelectorAll('select');
        for (const selectElem of selectElems) {
            const nameAttr = selectElem.getAttribute('name');
            if (nameAttr) {
                selectElem.name = nameAttr.replace(/\[\d+\]/, `[${index}]`);
                selectElem.id = nameAttr.replace(/\[\d+\]/, `_${index}_`);
            }
        }

        // Update image names and IDs (if applicable)
        const imageCoverElems = clone.querySelectorAll('img');
        for (const imageCoverElem of imageCoverElems) {
            const idAttr = imageCoverElem.getAttribute('id');
            imageCoverElem.id = idAttr.replace(/\d+/g, `${index}`);
        }
    }

    add() {
        const clone = this.modelRow.cloneNode(true);
        clone.classList.remove('hidden');

        const newIndex = this.getNextIndex();
        this.setClonedInputNames(clone, newIndex);

        // Clear input and image values for the newly added row
        const inputElems = clone.querySelectorAll('input, textarea');
        for (const elem of inputElems) {
            elem.value = '';

            if (elem.tagName === 'TEXTAREA') {
                elem.dataset.formId = newIndex;
            }
        }

        const selectElems = clone.querySelectorAll('select');
        for (const selectElem of selectElems) {
            selectElem.value = '1';
        }

        const fileElems = clone.querySelectorAll('input[type="file"]');
        for (const fileElem of fileElems) {
            fileElem.value = null;
        }

        const iframeElems = clone.querySelectorAll('iframe');
        for (const iframeElem of iframeElems) {
            iframeElem.remove();
        }

        const imgElems = clone.querySelectorAll('img');
        for (const imgElem of imgElems) {
            imgElem.src = '';
        }

        // Insert the new row before the specified button
        this.$el.insertBefore(clone, this.addButton);
        //this.initializeTinyMCE(clone);
        window.$components.init(clone);
    }

    getNextIndex() {
        const last = Array.from(
            document.querySelectorAll('.dynamic-forms-container')
        ).pop();

        return parseInt(last.dataset.index) + 1;
    }

    initializeTinyMCE(element) {
        const textareaElems = element.querySelectorAll('textarea');
        for (const textareaElem of textareaElems) {
            tinymce.init({
                target: textareaElem,
                height: 300, // Set the desired height of the editor
                menubar: false, // Hide the default menubar
                plugins: [

                ],
                toolbar: 'undo redo | formatselect | ' +
                    'bold italic backcolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat',
            });
        }

    }
}
